import { isApiError } from './api-client';

/** Network retries of one idempotent command (the same operation id on every attempt). */
const MAX_ATTEMPTS = 3;
const RETRY_DELAY_MS = 300;

const delay = (ms: number) =>
  new Promise<void>((resolve) => {
    setTimeout(resolve, ms);
  });

/**
 * Runs an idempotent command, retrying only when the server could not be reached. The caller
 * passes the same operation id in every attempt, so a request that did reach the server is
 * replayed there instead of being applied twice. Server answers (errors included) are final.
 */
export async function withNetworkRetries<T>(call: () => Promise<T>): Promise<T> {
  for (let attempt = 1; ; attempt++) {
    try {
      return await call();
    } catch (error) {
      if (!isApiError(error) || error.code !== 'network' || attempt >= MAX_ATTEMPTS) throw error;
      await delay(RETRY_DELAY_MS * attempt);
    }
  }
}
